import { gql } from '@apollo/client';
import {
  BASE_PLOT_FRAGMENT,
  NEIGHBOURING_PLOT_FRAGMENT,
  PLOT_FRAGMENT,
} from 'graphql/secure/fragments/plot.fragment';

export const GET_PLOTS = gql`
  query GetPlots($filters: PlotsFilters, $first: Int, $after: String, $before: String, $last: Int) {
    plots(first: $first, after: $after, before: $before, last: $last, filters: $filters) {
      edges {
        node {
          ...basePlotValues
        }
      }
      count
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${BASE_PLOT_FRAGMENT}
`;

export const GET_PLOTS_WITH_FARMS = gql`
  query GetPlots($filters: PlotsFilters, $first: Int, $after: String, $before: String, $last: Int) {
    plots(first: $first, after: $after, before: $before, last: $last, filters: $filters) {
      edges {
        node {
          ...plotValues
        }
      }
      count
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${PLOT_FRAGMENT}
`;

export const GET_NEIGHBOURING_FARM_PLOTS = gql`
  query GetNeighbouringFarmPlots($input: NeighbouringFarmPlotsInput!) {
    neighbouringFarmPlots(input: $input) {
      edges {
        node {
          ...neighboringPlotValues
        }
      }
      count
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${NEIGHBOURING_PLOT_FRAGMENT}
`;
